import { Component, OnInit } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { Subject, debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { ServiceService } from '../service/service-list.service';

@Component({
  selector: 'app-service-list',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, DecimalPipe],
  templateUrl: './service-list.component.html',
})
export class ServiceListComponent implements OnInit {
  serviceList: any[] = [];
  searchTerm = '';
  serviceLoading = false;

  // Pagination
  totalItems = 0;
  pageSize = 20;
  currentPage = 1;
  totalPages = 1;
  Math = Math;

  // Computed array for page buttons
  get pages(): number[] {
    return Array.from({ length: this.totalPages || 1 }, (_, i) => i + 1);
  }

  private searchTerms = new Subject<string>();

  constructor(private serviceService: ServiceService, private router: Router) {}

  ngOnInit(): void {
    this.setupSearchDebounce();
    this.loadServices();
  }

  setupSearchDebounce(): void {
    this.searchTerms
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((term: string) => {
          this.serviceLoading = true;
          this.currentPage = 1;
          return this.serviceService.getServices(
            this.currentPage,
            this.pageSize,
            term
          );
        })
      )
      .subscribe({
        next: (response) => this.handleResponse(response),
        error: (err) => {
          console.error('Search failed', err);
          this.serviceLoading = false;
        },
      });
  }

  loadServices(): void {
    this.serviceLoading = true;
    this.serviceService
      .getServices(this.currentPage, this.pageSize, this.searchTerm)
      .subscribe({
        next: (response) => this.handleResponse(response),
        error: (err) => {
          console.error('Error fetching services:', err);
          this.serviceLoading = false;
        },
      });
  }

  private handleResponse(response: any): void {
    // ✅ Match exact keys from your API
    this.serviceList = response?.data || [];
    this.totalItems = response?.total || 0;
    this.currentPage = response?.page || 1;
    this.totalPages = response?.pageCount || 1;
    this.pageSize = response?.limit || 20;
    this.serviceLoading = false;
  }

  onSearch(): void {
    this.searchTerms.next(this.searchTerm);
  }

  pageSizeChange(): void {
    this.currentPage = 1;
    this.loadServices();
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
      this.currentPage = page;
      this.loadServices();
    }
  }

  downloadServiceReport(serviceId: string): void {
    console.log(`Downloading report for service ID: ${serviceId}`);
  }
}
